import { VspeedModal } from './VspeedModal';
export default VspeedModal;
